import { T } from '@transifex/react';
import { Badge } from '~/components/ui/badge';
import { XpIcon } from '~/components/ui/gamification/icons/xp-icon';
import { getXpLevelConfig, getXpLevelName, type XpLevel } from '~/lib/xp-levels';
import { ToastLayout } from '../../toast-layout';

type GamificationLevelUpToastProps = {
  title: string;
  currentLevel: XpLevel;
  nextLevel?: XpLevel;
  nextLevelXp?: number;
  toastId?: string | number;
};

export function GamificationLevelUpToast({
  title,
  currentLevel,
  nextLevel,
  nextLevelXp,
  toastId,
}: GamificationLevelUpToastProps) {
  const currentLevelIcon = getXpLevelConfig(currentLevel).badgeSrc;

  return (
    <ToastLayout
      title={title}
      icon={
        <img src={currentLevelIcon} alt="" className="h-auto w-11 shrink-0" aria-hidden="true" />
      }
      contentClassName="gap-xs"
      borderColor="border-green-500"
      toastId={toastId}
    >
      {nextLevel !== undefined && nextLevelXp !== undefined && (
        <p className="inline-flex flex-wrap items-center gap-sm text-body-big">
          <T
            _str="Next up: {nextLevel} {xpBadge}"
            nextLevel={getXpLevelName(nextLevel)}
            xpBadge={
              <Badge
                variant="green"
                size="large"
                className="text-body-small-bold inline-flex items-center gap-xs"
              >
                <XpIcon size="xs" aria-hidden />
                <T _str="{nextLevelXp} XP" nextLevelXp={nextLevelXp} />
              </Badge>
            }
          />
        </p>
      )}
    </ToastLayout>
  );
}
